<section class="context-account">
  @if ((isMobileAndTabletPortrait$ | async) === false) {
    <div class="context-account__block-text context-account__block-text__top">
      <p class="context-account__text" i18n="@@context.account.discover-universe-wizbii">
        Découvrez <span class="highlighted">l&apos;univers WIZBII&nbsp;!</span>
      </p>
    </div>
    <div class="context-account__block-text context-account__block-text__bottom">
      <p class="context-account__text" i18n="@@context.account.optimistic-moment">
        Nous transformons le passage à la vie active en
        <span class="highlighted">un moment optimiste et stimulant</span>
      </p>
    </div>
    <img class="context-account__background-image" src="assets/images/context-account/woman.png" alt="WIZBII" />
  } @else {
    <p class="context-account__pop-up" i18n="@@context.account.discover-universe-wizbii">
      Découvrez <span class="highlighted">l&apos;univers WIZBII&nbsp;!</span>
    </p>
  }
</section>
